// SignalBars.tsx
import React from 'react';

const SignalBarsRight: React.FC = () => {
  return (
    <div className="ml-10 flex items-center justify-center space-x-1">
      {Array.from({ length: 12 }).map((_, index) => (
        <div
          key={index}
          className="w-1 animate-signalBar rounded bg-gradient-to-r from-signal-start via-signal-mid to-signal-end"
          style={{ animationDelay: `${index * 0.1}s` }}
        ></div>
      ))}
    </div>
  );
};

export default SignalBarsRight;
